import PieChartComponent from '../utils/PieChartComponent';
import { getTotalsGraph } from '../DiscipleshipCharts';

export const DiscipleshipLeadersCharts = ({
  leadersAmountByLeadershipTypeDataForPieChart,
  leadersByGenderPieChartData,
}) => {
  return (
    <>
      <div className="totalLabels">
        Total de líderes: {getTotalsGraph(leadersAmountByLeadershipTypeDataForPieChart)}
      </div>
      <div className="chartSection">
        <PieChartComponent
          title="Por tipo de grupo que lideran"
          data={leadersAmountByLeadershipTypeDataForPieChart}
          pieType="leader"
        />
        <PieChartComponent title="Por género" data={leadersByGenderPieChartData} pieType="leader" />
      </div>
    </>
  );
};
